export default __webpack_public_path__ + "static/media/logo.3840b703.png";